export default __webpack_public_path__ + "img/right4.0cad0557.jpg";